import React, { useEffect, useState, Fragment } from 'react';
import ROLES from '../../company_roles/rol';
interface CustomTableProps {
  data: any;
  onDataChange: (newData: { fetch_roles: any[]; custom_roles: any }, user_roles?: any) => void;
}


const CustomTable: React.FC<CustomTableProps> = ({ data, onDataChange }) => {
  const [customRoles, setCustomRoles] = useState(data?.custom_roles);


  useEffect(() => {
    // Notificar al padre solo con custom_roles modificado
    onDataChange({ ...data, custom_roles: customRoles });
  }, [customRoles]);

  return <ROLES operation={data?.method} modules={data?.fetch_roles} setCustomRoles={setCustomRoles} user_roles={data?.user_roles} />;
};

export default CustomTable;